import { render } from "./GardeshList.vue?vue&type=template&id=4524673e"
import script from "./GardeshList.vue?vue&type=script&lang=js"
export * from "./GardeshList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__